<script setup lang="ts">
import { computed } from 'vue';

import { GrammarMenuItem } from '@nora-monorepo/grammar-ui';
import { DrawLayerTypeEnum } from '@nora-monorepo/nora-api-client';

import { useMapStore } from '#nora-ui/map/stores/map-store';

interface Props {
  selectedDrawLayerId?: string;
  mapId: string;
}

const props = defineProps<Props>();
const emit = defineEmits(['selectDrawLayer']);

const mapStore = useMapStore();
const map = mapStore.getMapByIdOrThrow(props.mapId);

const menuItems = computed(() => {
  return map.state.draw.drawLayers
    .filter(drawLayer => drawLayer.type !== DrawLayerTypeEnum.GEOFENCE)
    .map(drawLayer => ({
      label: drawLayer.name,
      value: drawLayer.id,
      type: drawLayer.type,
    }));
});

function onMenuSelect(value: string) {
  emit('selectDrawLayer', value);
}
</script>

<template>
  <GrammarMenuItem
    v-for="item in menuItems"
    :key="item.value"
    :label="item.label"
    :value="item.value"
    :selected="item.value === props.selectedDrawLayerId"
    @select="() => onMenuSelect(item.value)"
  />
</template>
